import { withInstall } from '@bigin/utils'

import Scrollbar from './src/scrollbar.vue'

export const BScrollbar = withInstall(Scrollbar)
export default BScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
